// create resetPassword action
import { z } from "zod";
import { mapErrorsToFields } from "../../../utils";
import AuthService from "../../../services/AuthService";
import { AxiosError } from "axios";

export type State = {
  errors?: {
    email?: string[];
    code?: string[];
    password?: string[];
    confirmPassword?: string[];
    general?: string[];
  };
  success?: boolean;
  error?: {
    message: string;
    code: string;
  };
  defaultValues?: {
    email: string;
    code: string;
    password: string;
    confirmPassword: string;
  };
};
const FormSchema = z
  .object({
    email: z.email({
      error: "Email is not valid",
    }),
    code: z
      .string({
        error: "Please enter code.",
      })
      .length(6, { message: "Code must be equal 6 characters" }),
    password: z
      .string({
        error: "Please enter password.",
      })
      .min(6, { message: "Password must be more than or equal 6 characters" }),
    confirmPassword: z
      .string({
        error: "Please enter password confirmation.",
      })
      .min(6, { message: "Password must be more than or equal 6 characters" }),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: "Passwords don't match",
    path: ["confirmPassword"], // path of error
  });
const api = new AuthService();
export async function resetPassword(
  prevState: State | undefined,
  data: FormData
): Promise<State> {
  const defaultValues = {
    email: data.get("email")?.toString() || "",
    code: data.get("code")?.toString() || "",
    password: data.get("password")?.toString() || "",
    confirmPassword: data.get("confirmPassword")?.toString() || "",
  };

  const result = FormSchema.safeParse(defaultValues);
  console.log(result);
  if (!result.success) {
    const errors = mapErrorsToFields(result.error);
    return { ...prevState, errors, error: undefined };
  }

  try {
    const response = await api.resetPassword({
      email: data.get("email") as string,
      token: data.get("code") as string,
      newPassword: data.get("password") as string,
    });
    const success = response.status === 200;
    if (success)
      return {
        errors: {},
        defaultValues: defaultValues,
        error: undefined,
        success: success,
      };
  } catch (ex: AxiosError | any) {
    console.log({ ex });
    return {
      errors: {},
      defaultValues: defaultValues,
      error: {
        message: ex.response.data.description,
        code: ex.response.data.code,
      },
      success: false,
    };
  }

  return {
    errors: {},
    defaultValues: defaultValues,
    error: {
      message: "Failed to reset password.",
      code: "ResetPassword.error",
    },
    success: false,
  };
}